import { useEffect } from "react";

import HeaderSearch from "web/Layout/HeaderSearch";

import List from "./List";
import headerClasses from "./header.scss";
import classes from "./navigation.scss";

const Navigation = () => {
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return (
    <div className={classes.root}>
      <HeaderSearch classes={headerClasses} />
      <List />
    </div>
  );
};

export default Navigation;
